import { render, staticRenderFns } from "./SkeletonTable.vue?vue&type=template&id=24ca5474&scoped=true&"
import script from "./SkeletonTable.vue?vue&type=script&lang=js&"
export * from "./SkeletonTable.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonTable.vue?vue&type=style&index=0&id=24ca5474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca5474",
  null
  
)

export default component.exports